module.exports = "<h1>Order Validation</h1>\r\n<p *ngIf=\"!valid\">\r\n  <em>Please enter your validation code!</em>\r\n  <input type=\"text\" class=\"form-text\" name=\"code\" [(ngModel)]=\"code\" /><br />\r\n  <button class=\"btn btn-primary pull-left\" (click)=\"validateClick()\"><span class='fa fa-balance-scale'></span>&nbsp; Validate</button>\r\n</p>\r\n<p *ngIf=\"valid\">\r\n  <strong class=\"text-success\">Your code has been validated!</strong>\r\n  <app-invoice></app-invoice>\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/validate/validate.component.html
// module id = ./src/app/validate/validate.component.html
// module chunks = main